import { clearCareTeamMessageTopic } from "@/domains/progress/utils/care-team-message";
import { useCartStore, useSessionStore } from "@/stores";
import { unlockPageScroll } from "@/utils";

export const cleanUpUserSession = () => {
  useSessionStore.getState().setSession(null);
  sessionStorage.removeItem("careplanCartId");
  localStorage.removeItem("careplanVersion");
  clearCareTeamMessageTopic();
  useCartStore.getState().setRecommendedCartLines(null);
  useCartStore.getState().setCartCreationFailed(false);
  unlockPageScroll();
};
